export default "__VITE_ASSET__tyTfNkUl__"